<template>
  <button type="button" :data-clipboard-text="text"><slot></slot></button>
</template>

<script>
  import Clipboard from "clipboard"
  export default {
    name: 'Clipboard',
    props: ['text'],
    data () {
      return {
        clipboard: null
      }
    },
    mounted () {
      this.clipboard = new Clipboard(this.$el)
      this.clipboard.on('success', (e) => {
        e.clearSelection()
        this.$emit('copied')
      });
    },
    destroyed () {
      this.clipboard.destroy()
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

</style>



// WEBPACK FOOTER //
// src/components/_global/clipboard.vue